import React from "react";
import { Link } from "react-router-dom";

const PortfolioTab = (props) => {
  const { data, onlyPics } = props;
  return (
    <div className="row grid">
      {data.map((item, index) => {
        const cardClassName =
          item.fullWidth === true
            ? "single-portfolio col-sm-12 all web mb-3"
            : "single-portfolio col-sm-4 all web mb-3";

        const inner = (
          <>
            <div className="relative mb-2">
              <div className="thumb">
                <div className="overlay overlay-bg" />
                {item.fullWebSS === true ? (
                  <div className="screen">
                    <img
                      className=" image-prop img-fluid"
                      src={item.image}
                      alt={item.caption}
                    />
                  </div>
                ) : (
                  <img
                    className=" image-prop img-fluid"
                    src={item.image}
                    alt={item.caption}
                  />
                )}
              </div>
              {/* <a href={item.image} className="img-pop-up">
                <div className="middle">
                  <div className="text align-self-center d-flex">
                    <img src="img/preview.png" alt={item.caption} />
                  </div>
                </div>
              </a> */}
            </div>
            {onlyPics === false && (
              <div className="p-inner">
                <h4>{item.title}</h4>
                <div className="cat">{item.caption}</div>
              </div>
            )}
          </>
        );

        return item?.hasInnerPage === true ? (
          <Link
            to={`/ui-ux-project/${item.urlSuffix}`}
            className={cardClassName}
            key={index}
          >
            {inner}
          </Link>
        ) : (
          <div className={cardClassName} key={index}>
            {inner}
          </div>
        );
      })}
    </div>
  );
};

export default PortfolioTab;
